import { CustomerFlagDto, CustomerItemDto } from '@/api/generated';
import {
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { CustomerSearchFormModel } from '@/views/customers/list/model/CustomersSearchForm.model.ts';

export type CustomersViewTranslation = {
  header: {
    button: {
      add: string;
    };
    menu: CustomerTypeOptionsTranslation;
  };
  table: {
    body: Record<keyof Omit<CustomerItemDto, 'customerId'>, Record<string, string> | string> & {
      flagOption: Record<CustomerFlagDto, string>;
      statusOption: CustomerStatusOptionsTranslation;
      typeOption: CustomerTypeOptionsTranslation;
    };
    details: {
      address: string;
      company: string;
      open: string;
      regon: string;
    };
    head: Record<keyof CustomerSearchFormModel, string>;
    quickFilters: {
      mine: string;
      mineTooltip: string;
    };
  };
};

export const customersViewTranslation: CustomersViewTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
    menu: customerTypeOptionsTranslation,
  },
  table: {
    body: {
      address: 'Adres',
      distinguishingLabel: 'Wyróżnik',
      flag: 'Flaga',
      flagOption: flagOptionsTranslation,
      name: 'Nazwa',
      nip: 'NIP',
      status: 'Status',
      statusOption: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOption: customerTypeOptionsTranslation,
    },
    details: {
      address: 'Adres',
      company: 'Dane klienta',
      open: 'Otwórz klienta',
      regon: 'REGON',
    },
    head: {
      fullTextSearchInput: 'Szukaj',
      ownerIdOfCustomerContact: 'Opiekun kontaktu',
    },
    quickFilters: {
      mine: 'Tylko moi',
      mineTooltip: 'Klienci, w których jestem opiekunem któregoś z kontaktów',
    },
  },
};
